import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Sobre mí',
    href: '#about'
  }, {
    name: 'Servicios',
    href: '#services'
  }, {
    name: 'Enfoque',
    href: '#approach'
  }, {
    name: 'Proceso',
    href: '#process'
  }, {
    name: 'Contacto',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${isScrolled ? 'shadow-sm' : ''}`} data-id="element-173">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-174">
        <div className="flex justify-between items-center h-20" data-id="element-175">
          {/* Logo */}
          <a href="#" className="flex flex-col" data-id="element-176">
            <span className="font-serif text-2xl font-bold text-gray-900 tracking-tight" data-id="element-177">
              Juliet González
            </span>
            <span className="text-xs uppercase tracking-widest font-medium text-gray-500" data-id="element-178">
              Psicóloga Clínica
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-179">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors" data-id="element-180">
                {link.name}
              </a>)}
            <a href="#contact" className="inline-flex items-center px-5 py-2.5 text-sm font-medium rounded-lg text-white bg-teal-700 hover:bg-teal-800 transition-colors shadow-sm" data-id="element-181">
              Agendar cita
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-182">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 rounded-md text-gray-600 hover:bg-gray-100 focus:outline-none" aria-label="Toggle menu" data-id="element-183">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-184" /> : <Menu className="w-6 h-6" data-id="element-185" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-186">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-187">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-188">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-gray-700 hover:bg-gray-50 rounded-md" data-id="element-189">
                  {link.name}
                </a>)}
              <div className="pt-4" data-id="element-190">
                <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-center w-full px-4 py-3 text-base font-medium rounded-lg text-white bg-teal-700 hover:bg-teal-800" data-id="element-191">
                  Agendar cita
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}